import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectItemTypesReducer(state = initialState.projectItemTypesList, action) {   

    switch (action.type) {
        case types.LOAD_PROJECTITEMTYPES_SUCCESS:
            return action.projectItemTypesList;     
        default:
            return state;
    }
}